import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ControlContainer, FormGroupDirective, Validators } from '@angular/forms';
import { DomainData } from 'src/app/model/domain-data';
import { dropdownValidator } from 'src/app/utils/validators';

@Component({
  selector: 'insert-edit-dropdown',
  templateUrl: './dropdown.component.html',
  viewProviders: [
    { provide: ControlContainer, useExisting: FormGroupDirective }
  ]
})
export class DropdownComponent implements OnChanges {
  @Input() fieldName!: string;
  @Input() label!: string;
  @Input() domain!: DomainData[];
  @Input() required: boolean = false;

  @Output() change: EventEmitter<DomainData> = new EventEmitter<DomainData>();

  constructor(private formGroupDirective: FormGroupDirective) {}

  ngOnChanges(changes: SimpleChanges) {
    if(!!changes['domain']) {
      let validators = !!this.required ? [Validators.required] : [];
      validators.push(dropdownValidator(changes['domain'].currentValue));
      this.getFormControlField()?.setValidators(validators);
    }
  }

  getDomain(): DomainData[] {
    return this.domain;
  }

  getFormControlField() {
    return this.formGroupDirective.form.get(this.fieldName);
  }

  onChange(value: string) {
    this.change.emit(this.domain.find(d => d.key === value));
  }

}
